:host {
  --aha-tab--horizontal-padding: 15px;
  --aha-tab--highlight-color: var(--theme-link-text);
  --aha-tab--badge--highlight-color: var(--theme-blue-background);
  --aha-tab--badge--focus-color: var(--theme-blue-border);

  --aha-tab--private--badge--background-color: var(--theme-tertiary-background);

  display: block;
  user-select: none;
}

:host(:not([data-in-menu])) {
  text-transform: uppercase;
  padding: 0 var(--aha-tab--horizontal-padding);
  cursor: pointer;
  white-space: nowrap;
  color: var(--theme-secondary-text);
  font-weight: 600;
  outline: 0;
}

:host(:not([data-in-menu])) #content {
  border-bottom: 2px solid;
  border-bottom-color: transparent;
  display: flex;
  gap: var(--spacer-2);
  align-items: center;
}

:host(:not([data-in-menu]):hover),
:host(:not([data-in-menu])[aria-selected='true']) {
  color: var(--aha-tab--highlight-color);
  --aha-tab--private--badge--background-color: var(--aha-tab--badge--highlight-color);
}

:host(:not([data-in-menu]):focus-visible) {
  background: var(--aha-blue-100);
  color: var(--aha-tab--highlight-color);
  --aha-tab--private--badge--background-color: var(--aha-tab--badge--focus-color);
}

:host(:not([data-in-menu])[aria-selected='true']) #content {
  border-bottom-color: var(--aha-tab--highlight-color);
}

:host(:not([data-in-menu])) .slot {
  padding: 12px 0;
}

:host(:not([data-in-menu])) a {
  color: inherit;
  text-decoration: none;
}

slot::slotted(*) {
  display: none;
}

slot[name='badge']::slotted(*),
.badge {
  background: var(--aha-tab--private--badge--background-color);
  flex-shrink: 0;
  min-width: 1em;
  height: 2em;
  border-radius: 100vw;
  font-size: 0.9em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5em;
}

:host([data-in-menu]) .badge {
  color: var(--theme-primary-text);
}
